<template>
  <div class="card">
    <div class="card-content">
      <a
        class="delete is-pulled-right has-background-danger"
        @click="() => confirmarEliminacionUsuario()"
      />
      <p class="title is-4">
        {{ usuario.nombre }}
      </p>
      <p class="subtitle is-6">
        {{ usuario.id }}
      </p>
    </div>
  </div>
</template>

<script>
import { zonaService } from '@/services'

export default {
  name: 'ZonaItem',
  props: {
    usuario: {
      type: Object,
      required: true
    },
    zona: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    quitarUsuario() {
      const self = this
      return zonaService
        .quitarUsuarioZona(self.zona.id, self.usuario.id)
        .then((response) => {
          self.$emit('remove', self.usuario.id)
          this.notificarAccionCompletada(response.data)
        })
        .catch((error) => this.procesarError(error))
    },

    confirmarEliminacionUsuario() {
      this.$buefy.dialog.confirm({
        title: 'Quitar usuario de zona',
        message: `¿Est&aacute; seguro de <b>quitar</b> el usuario de la zona <b>${this.zona.nombre}</b>?`,
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.quitarUsuario()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 5px;
  .card-content {
    padding: 0.5rem 1rem;
    .columns {
      margin-bottom: 0px;
      .column {
        padding: 0.5rem;
      }
    }
  }
}
</style>
